<pdq-tabs-group variant="underline" (onChange)="onTabChange($event)" [leftMargin]="'none'">
  @for (tab of tabs; track tab.value) {
    <pdq-tab [label]="tab.label" [value]="tab.value" [active]="tab.value === activeTab"></pdq-tab>
  }
</pdq-tabs-group>

<div class="order-editing-form-container">
  @switch (activeTab) {
    @case (OrderEditingFormTab.ORDER_EDITS) {
      <order-editing-form-repricing></order-editing-form-repricing>
      <order-editing-form-edits></order-editing-form-edits>
    }
    @case (OrderEditingFormTab.ADDRESS_VALIDATION) {
      <order-editing-form-address-validation></order-editing-form-address-validation>
    }
    @case (OrderEditingFormTab.SETTINGS) {
      <order-editing-form-period></order-editing-form-period>
      <order-editing-form-shipping></order-editing-form-shipping>
    }
  }
</div>
